import {
  HTTP_UPDATEINITIALAPPROVE_FETCHING,
  HTTP_UPDATEINITIALAPPROVE_SUCCESS,
  HTTP_UPDATEINITIALAPPROVE_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEINITIALAPPROVE_FETCHING:
      return { ...state, result: [], isLoading: true, isError: false };
    case HTTP_UPDATEINITIALAPPROVE_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATEINITIALAPPROVE_FAILED:
      return { ...state, result: [], isLoading: false, isError: true };
    default:
      return state;
  }
};
